import file1 from "./history.data.json"

export const getHistoryList = async () => {
  return file1
}